import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { BUSINESS } from "@/lib/constants";

export default function Privacy() {
  return (
    <PublicLayout>
      <Seo title="Privacy Policy | Site Cleanup" description="How Site Cleanup collects and uses information submitted through the quote request and contractor application forms." />
      <section className="py-16 md:py-24">
        <div className="rs-container max-w-3xl">
          <span className="rs-eyebrow">Privacy</span>
          <h1 className="mt-3 text-4xl md:text-6xl uppercase font-display">Privacy Policy</h1>
          <p className="text-sm text-muted-foreground mt-2">Last updated: {new Date().getFullYear()}</p>
          <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-asphalt/90">
            <div>
              <h2 className="font-display text-2xl uppercase">Information we collect</h2>
              <p className="mt-2">We may collect your name, phone number, email address, site address, suburb, state, postcode, job details, photos and any additional notes you provide through our quote request or contractor application forms.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl uppercase">How we use your information</h2>
              <p className="mt-2">We use your information to assess your enquiry, respond with a quote, and — where you consent — share the enquiry with a suitable local contractor who may be able to complete the work. Contractor applications are used to evaluate suitability for our network.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl uppercase">Photos & site information</h2>
              <p className="mt-2">Please do not submit sensitive personal information, identity documents or private information not required for a quote. If photos contain people, number plates or private documents, please remove or blur them where possible before uploading.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl uppercase">Storage & third parties</h2>
              <p className="mt-2">Enquiry data is stored in our secure lead management system. Where we forward an enquiry to a local contractor, only the details needed to quote and complete the job are shared.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl uppercase">Access & removal</h2>
              <p className="mt-2">You can request a copy of your data or ask us to remove it at any time by emailing <a className="text-safety underline" href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>.</p>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
